import React from 'react'
import { destroyPaymentCard } from '../../helpers/destroyPaymentCard'
import DeleteModal from '../../components/DeleteModal'

const DeleteCardModal = ({
  isOpen,
  closeModal,
  isDesktop,
  cardToDestroy,
  paymentMethods,
  me,
  setUser,
  selectedPaymentMethodId,
  setHasExistingPaymentMethods
}) => {
  const deletePaymentMethod = async () => {
    try {
      const methods = await destroyPaymentCard(
        cardToDestroy,
        paymentMethods,
        me,
        setUser,
        selectedPaymentMethodId,
      )
      if (!methods) {
        setHasExistingPaymentMethods(false)
      }

      closeModal()
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <DeleteModal 
      isDesktop={isDesktop}
      isOpen={isOpen}
      closeModal={closeModal}
      deleteFn={deletePaymentMethod}
      cancelConfirmText='Are you sure you want to delete this payment method?'
      
    />
  )
}

export default DeleteCardModal
